// extracted by mini-css-extract-plugin
export default {"loader":"style_loader__AXZdt","l27":"style_l27__kCRIM"};